<nav class="rail" aria-label="Choose a series">
  <div class="rail-head">
    <span>Every series</span>
    <span class="rail-range">27 back to 51</span>
  </div>
  <div class="rail-body">
    <button type="button" class="arrow arrow--l" aria-label="Newer series"
            [class.is-off]="!canLeft" (click)="page(-1)">&lsaquo;</button>

    <div class="scroller" #scroller (scroll)="updateEdges()">
      <ng-container *ngFor="let it of items; trackBy: trackByYear">
        <span class="break" *ngIf="it.yearBreak" aria-hidden="true"></span>
        <a class="it"
           [class.is-current]="it.year === year"
           [routerLink]="link(it.year)"
           [attr.aria-current]="it.year === year ? 'page' : null"
           [attr.aria-label]="it.year + ' series, ' + it.label">
          <span class="tag" *ngIf="it.tag">{{ it.tag }}</span>
          <span class="plate plate-font"><span class="f">AB</span>{{ it.year }}<span class="f">&nbsp;CDE</span></span>
          <span class="when">{{ it.label }}</span>
        </a>
      </ng-container>
    </div>

    <button type="button" class="arrow arrow--r" aria-label="Older series"
            [class.is-off]="!canRight" (click)="page(1)">&rsaquo;</button>
  </div>
</nav>
